import React from "react";
import logoSm from "../../assets/images/logo-sm.png";

interface AuthLeftPanelProps {
  title: string;
  description: string;
}

const AuthLeftPanel: React.FC<AuthLeftPanelProps> = ({ title, description }) => {
  return (
    <div className="auth-left-panel">
      <div className="auth-left-panel-content">
        <div className="auth-main-text">
          <h1 className="auth-title">{title}</h1>
          <p className="auth-description">{description}</p>
        </div>

        <div className="auth-logo-bottom">
          <img src={logoSm} alt="Amanat Logo" height="40" />
          <div className="logo-text">
            <h4>Amanat</h4>
            <p>Enabling Financial Well-being for All</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLeftPanel;



